var $4a6b836d4f1bfaba$exports = {};
$4a6b836d4f1bfaba$exports = {
  "alpha": "\uC54C\uD30C",
  "black": "\uAC80\uC740\uC0C9",
  "blue": "\uD30C\uB791",
  "blue purple": "\uCCAD\uC790\uC0C9",
  "brightness": "\uBA85\uB3C4",
  "brown": "\uAC08\uC0C9",
  "brown yellow": "\uD669\uAC08\uC0C9",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, ", ").concat(args.chroma, ", ").concat(args.hue);
  },
  "cyan": "\uCCAD\uB85D\uC0C9",
  "cyan blue": "\uCCAD\uB85D\uC0C9",
  "dark": "\uB2E4\uD06C",
  "gray": "\uD68C\uC0C9",
  "grayish": "\uD68C\uAC08\uC0C9",
  "green": "\uCD08\uB85D",
  "green cyan": "\uCCAD\uB85D\uC0C9",
  "hue": "\uC0C9\uC870",
  "light": "\uB77C\uC774\uD2B8",
  "lightness": "\uBC1D\uAE30",
  "magenta": "\uC790\uD64D\uC0C9",
  "magenta pink": "\uB9C8\uC820\uD0C0 \uD551\uD06C",
  "orange": "\uC8FC\uD669\uC0C9",
  "orange yellow": "\uBD88\uADF8\uC2A4\uB984\uD55C \uB178\uB791",
  "pale": "\uD759\uC0C9",
  "pink": "\uBD84\uD64D\uC0C9",
  "pink red": "\uD551\uD06C \uB808\uB4DC",
  "purple": "\uC790\uC8FC\uC0C9",
  "purple magenta": "\uBCF4\uB77C\uBE5B \uC790\uD64D\uC0C9",
  "red": "\uBE68\uAC15",
  "red orange": "\uBD89\uC740 \uC8FC\uD669\uC0C9",
  "saturation": "\uCC44\uB3C4",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, ", ").concat(args.chroma, ", ").concat(args.hue, ", ").concat(args.percentTransparent, " \uD22C\uBA85\uB3C4");
  },
  "very dark": "\uB9E4\uC6B0 \uC5B4\uB450\uC6B4",
  "very light": "\uB9E4\uC6B0 \uC5F0\uD568",
  "vibrant": "\uAC15\uB82C\uD55C",
  "white": "\uD770\uC0C9",
  "yellow": "\uB178\uB780\uC0C9",
  "yellow green": "\uC5F0\uB450\uC0C9"
};
export { $4a6b836d4f1bfaba$exports as default };